import getClientId from '../storage/getClientId';
import getVisitorId from '../storage/getVisitorId';

/**
 * Returns the latest contents of a panel for a specified leadform.
 */
function getContents(dataLayer, formVersion, panels) {
  const contents = [];
  [...dataLayer].reverse().forEach(item => {
    if (item && item.event === 'lead_form_selection' && item.leadform_id === formVersion && item.panel_name &&
       !panels.has(item.panel_name)) {
      panels.add(item.panel_name);
      contents.push( `${item.panel_name} | ${item.contents}` );
    }
  });

  return contents;
}

export default function(formVersion) {
  if (formVersion && window.dataLayer && window.dataLayer.length) {
    const panels = new Set();
    window.dataLayer.push({
      event: 'lead_form_complete',
      contents: getContents(dataLayer, formVersion, panels),
      panel_count: panels.size,
      leadform_id: formVersion,
      visitor_id: getVisitorId(),
      client_id: getClientId(),
    });
  }
}
